var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VueDatePicker',{attrs:{"disabled-picker":_vm.disabled,"format":"dd/MM/yy","value":_vm.value || Date.now()},on:{"input":_vm.onInput}})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70fdbcf7","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/DatePicker.vue
// module id = 673
// module chunks = 1